import React, { Component } from 'react'
import { connect } from 'react-redux';
import { path } from 'ramda';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { saveEmployeesFieldSettings } from '../../api/employees';

export class FieldsOptions extends Component {
    // To suppress react warning about not using key for iterated elements
    // The reason why supression is required is because checkbox does not reflect it visual state
    // after clicking EXACTLY on it once it was droped to a new possition
    fakeKey = 0;
    constructor(props) {
        super(props);

        const fields = path(['employees', 'fields'], this.props) || [];

        this.state = {
            fields: [...fields].map(f => Object.assign({}, f)).map(this.updateFakeKey),
            changed: false
        }
    }

    updateFakeKey = (field) => {
        field.fakeKey = ++this.fakeKey;
        return field;
    }

    onDragEnd = res => {
        if (!res.destination) {
            return;
        }

        const fields = this.reorder(this.state.fields, res.source.index, res.destination.index);
        this.setState({
            fields: fields,
            changed: true
        });
    }

    reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, this.updateFakeKey(removed));

        return result;
    }

    getItemStyle = (isDragging, draggableStyle) => ({
        background: isDragging ? "rgba(255, 255, 255, 0.8)" : "white",
        ...draggableStyle
    })

    getListStyle = (isDraggingOver) => ({
        background: isDraggingOver ? "rgb(245, 245, 245)" : "white"
    })

    rejectChanges = () => {
        this.complete();
    }

    applyChanges = () => {
        const fields = this.state.fields;
        let idx = -1;

        fields.forEach(f => {
            f.sort_order = ++idx;
            delete f.fakeKey;
        });

        this.props.save(this.state.fields);
        this.complete();
    }

    complete = () => {
        if (this.props.onComplete) {
            this.props.onComplete();
        }
    }


    onDisplayChanged = (evt) => {
        const { fields } = this.state;
        const field = fields.find(f => f.name === evt.target.name);
        if (field) {
            field.display = evt.target.checked ? 1 : 0;
            this.setState({
                fields: fields,
                changed: true
            });
        }
    }

    render() {
        const fields = this.state.fields;
        const changed = this.state.changed;

        return (
            <div className='field_options'>
                <div className="top">
                    {!changed && <span className="msg">Hold an item and move it to change its position in the table.</span>}
                    {changed &&
                        <div>
                            <button className="btn btn-danger btn-outline float-right" style={{ 'marginLeft': '10px' }} onClick={this.rejectChanges}>
                                <i className="fa fa-remove"></i>
                                <span style={{ 'paddingLeft': '3px' }}>Cancel</span>
                            </button>
                            <button className="btn btn-success btn-outline float-right" onClick={this.applyChanges}>
                                <i className="fa fa-check"></i>
                                <span style={{ 'paddingLeft': '3px' }}>Apply changes</span>
                            </button>
                        </div>
                    }
                </div>
                <div>
                    <DragDropContext onDragEnd={this.onDragEnd}>
                        <Droppable droppableId="droppable" ignoreContainerClipping={true}>
                            {(provided, snapshot) => (
                                <ul
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                    style={this.getListStyle(snapshot.isDraggingOver)}
                                >
                                    {fields.map((field, index) => (
                                        <Draggable key={field.fakeKey} draggableId={field.name} index={index}>
                                            {(provided1, snapshot1) => (
                                                <li
                                                    ref={provided1.innerRef}
                                                    {...provided1.draggableProps}
                                                    {...provided1.dragHandleProps}
                                                    style={this.getItemStyle(snapshot1.isDragging, provided1.draggableStyle)}
                                                >
                                                    <label>
                                                        <input type="checkbox" name={field.name} defaultChecked={field.display === 1} onChange={this.onDisplayChanged} /> {field.title}
                                                    </label>
                                                    <i className="fa fa-sort" title="Drag and drop"></i>
                                                </li>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </ul>
                            )}
                        </Droppable>
                    </DragDropContext>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToProps = (dispatch) => {
    return {
        save: fields => {
            saveEmployeesFieldSettings(fields)(dispatch);
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FieldsOptions);


// WEBPACK FOOTER //
// ./src/containers/Employees/fieldsOptions.js